export default __webpack_public_path__ + "static/media/h-bar.4e03001c.svg";